import { api } from './index';
/* eslint-disable max-len */
// lead
export const addLeadTaskAssignment = (orgId, leadId, loginId, taskId) => {
  return api.post(`/api/organization/${orgId}/leads/${leadId}/checklist/logins/${loginId}/items`, {
    assignment_reference: null,
    focus_level: 2,
    login_id: loginId,
    task_id: taskId,
  });
};

export const deleteLeadTaskAssignment = (orgId, leadId, loginId, taskId) => {
  return api.post(`/api/organization/${orgId}/leads/${leadId}/checklist/logins/${loginId}/items/${taskId}?drop`);
};

export const addLeadTaskComment = (orgId, leadId, taskId, comment) => {
  return api.post(`/api/organization/${orgId}/leads/${leadId}/checklist/items/${taskId}/comments`, {
    body: comment,
  });
};

export const deleteLeadTaskComment = (orgId, leadId, taskId, commentId) => {
  return api.delete(`/api/organization/${orgId}/leads/${leadId}/checklist/items/${taskId}/comments/comment/${commentId}`);
};

export const editLeadTaskComment = (orgId, leadId, taskId, commentId, comment) => {
  return api.put(`/api/organization/${orgId}/leads/${leadId}/checklist/items/${taskId}/comments/comment/${commentId}`, {
    body: comment,
  });
};

export const getLeadTaskComments = (orgId, leadId, taskId) => {
  return api.get(`/api/organization/${orgId}/leads/${leadId}/checklist/items/${taskId}/comments`);
};


// project
export const addProjectTaskAssignment = (projectId, loginId, taskId) => {
  return api.post(`/api/wedding/${projectId}/checklist/logins/${loginId}/items`, {
    assignment_reference: null,
    focus_level: 2,
    login_id: loginId,
    task_id: taskId,
  });
};

export const deleteProjectTaskAssignment = (projectId, loginId, taskId) => {
  return api.post(`/api/wedding/${projectId}/checklist/logins/${loginId}/items/${taskId}?drop`);
};

export const addProjectTaskComment = (projectId, taskId, comment) => {
  return api.post(`/api/wedding/${projectId}/checklist/items/${taskId}/comments`, {
    body: comment,
  });
};

export const deleteProjectTaskComment = (projectId, taskId, commentId) => {
  return api.delete(`/api/wedding/${projectId}/checklist/items/${taskId}/comments/comment/${commentId}`);
};

export const editProjectTaskComment = (projectId, taskId, commentId, comment) => {
  return api.put(`/api/wedding/${projectId}/checklist/items/${taskId}/comments/comment/${commentId}`, {
    body: comment,
  });
};

export const getProjectTaskComments = (projectId, taskId) => {
  return api.get(`/api/wedding/${projectId}/checklist/items/${taskId}/comments`);
};


// general
export const addGeneralTaskAssignment = (loginId, taskId) => {
  return api.post(`/api/tasks/${taskId}`, {
    assignment_reference: null,
    focus_level: 2,
    login_id: loginId,
    task_id: taskId,
  });
};

export const deleteGeneralTaskAssignment = (loginId, taskId) => {
  return api.delete(`/api/tasks/${taskId}/assignments/${loginId}`);
};

export const addGeneralTaskComment = (taskId, comment) => {
  return api.post(`/api/tasks/${taskId}/comments`, {
    body: comment,
  });
};

export const deleteGeneralTaskComment = (taskId, commentId) => {
  return api.delete(`/api/tasks/${taskId}/comments/comment/${commentId}`);
};

export const editGeneralTaskComment = (taskId, commentId, comment) => {
  return api.put(`/api/tasks/${taskId}/comments/comment/${commentId}`, {
    body: comment,
  });
};

export const getGeneralTaskComments = (taskId) => {
  return api.get(`/api/tasks/${taskId}/comments`);
};
/* eslint-enable max-len */
